<template>
  <main>
    <div class="flex justify-center">
      <Message severity="error" class="text-4xl font-bold px-16">
        La page que vous demandez n'existe pas
      </Message>
    </div>
    <div class="flex justify-center mt-8">
      <RouterLink to="/">
        <Button severity="info" class="font-bold px-8"> Retour à l'accueil </Button>
      </RouterLink>
    </div>
  </main>
</template>

<script setup></script>
